<template>
    <div class="collapsible-body">
        <div class="row baseheader" style="width: 100%;">
            <div class="col s3"><span v-on:click="setMaintenacesOrder('date')">{{$t('maintenaces.date')}}</span>
              <i class="material-icons dp6" v-if="ordermaintenacesby == 'date' && ordermaintenace == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="ordermaintenacesby == 'date' && ordermaintenace == 'asc'">arrow_drop_up</i>
                <select id="maintenacetimerangesearch" v-model="rangeSelected">
                  <option value="currentMonth">{{$t('calendar.current_month')}}</option>
                  <option value="prevMonth">{{$t('calendar.prev_month')}}</option>
                  <option value="lastThreeMonths">{{$t('calendar.last_three_months')}}</option>
                  <option value="currentYear">{{$t('calendar.current_year')}}</option>
                  <option value="prevYear">{{$t('calendar.previous_year')}}</option>
                  <option value="other">{{$t('calendar.other_range')}}</option>
                </select>
                <div class="row" v-if="rangeSelected == 'other'">
                  <div class="col s6 input-field" style="padding-left: 0px;padding-right: 5px; min-width: 13ch;">
                    <input type="date" v-model="fromSelected"/>
                    <button class="waves-effect waves-light btn-large gray" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px; padding-right: 0px; width: 100%" v-on:click="cancelChanges()">{{$t('calendar.cancel')}}</button>
                  </div>
                  <div class="col s6 input-field" style="padding-right: 5px;padding-left: 5px; min-width: 13ch;">
                    <input type="date" v-model="toSelected"/>
                    <button class="waves-effect waves-light btn-large green" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px; padding-right: 0px; width: 100%" v-on:click="applyChanges()">{{$t('calendar.apply')}}</button>
                  </div>
                </div>
            </div>
            <div class="col s3 input-field">
              <span v-on:click="setMaintenacesOrder('name')">{{$t('maintenaces.place')}}</span>
              <i class="material-icons dp6" v-if="ordermaintenacesby == 'name' && ordermaintenace == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="ordermaintenacesby == 'name' && ordermaintenace == 'asc'">arrow_drop_up</i>
                <input name="maintenacesearch"  v-model="maintenacesearch" />
              </div>
            <div class="col s2"><span v-on:click="setMaintenacesOrder('what')">{{$t('maintenaces.whatdone')}}</span>
              <i class="material-icons dp6" v-if="ordermaintenacesby == 'what' && ordermaintenace == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="ordermaintenacesby == 'what' && ordermaintenace == 'asc'">arrow_drop_up</i>
                <selector  v-model="selected_kinds" :items="kinds" identifier="workerselector" v-if="loaded"></selector>
            </div>
            <div class="col s4"><span v-on:click="setMaintenacesOrder('devices')">{{$t('maintenaces.devices')}}</span>
              <i class="material-icons dp6" v-if="ordermaintenacesby == 'devices' && ordermaintenace == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="ordermaintenacesby == 'devices' && ordermaintenace == 'asc'">arrow_drop_up</i>
            </div>
        </div>
        <template v-if="loaded">
            <template v-for="maintenace in listMaintenaces">
                <div class="row">
                    <div class="col s3" :style="">{{maintenace.date | formatDate}}</div>
                    <div class="col s3">{{maintenace.name}}</div>
                    <div class="col s2">{{maintenace.what}}</div>
                    <div class="col s4" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                        <popup :text="maintenace.devices.join(', ')" v-bind:title="maintenace.name + ', ' + maintenace.date + ' ' + maintenace.what" v-bind:lines="[$t('maintenaces.devices') + ':', maintenace.devices.join(', ')]" />
                    </div>
                </div>
            </template>
            <div class="row" v-if="maintenaces.length == 0">
                <div class="col s12">{{$t('maintenaces.not_found')}}</div>
            </div>
        </template>
        <preloader v-else n="4" />
    </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
export default {
    data: function() {
        return {
            loaded: false,
            maintenaces: [],
            ordermaintenacesby: 'date',
            ordermaintenace: 'asc',
            maintenacesearch: '',
            selected_kinds: [],
            rangeSelected: "currentMonth",
            lastRange: "currentMonth",
            from: moment().startOf("month"),
            to: moment().endOf("month"),
            fromSelected: moment().startOf("month").format("YYYY-MM-DD"),
            toSelected: moment().endOf("month").format("YYYY-MM-DD")
        }
    },
    created: function() {
        this.load();
    },
    watch: {
      rangeSelected: function (val) {
        if(val == "currentMonth"){
          this.lastRange = val;
          this.from = moment().startOf("month").format("YYYY-MM-DD")
          this.fromSelected = moment().startOf("month").format("YYYY-MM-DD")
          this.to = moment().endOf("month").format("YYYY-MM-DD")
          this.toSelected = moment().endOf("month").format("YYYY-MM-DD")
        }else if(val == "prevMonth"){
          this.lastRange = val;
          this.from = moment().subtract(1,'months').startOf("month").format("YYYY-MM-DD")
          this.fromSelected = moment().subtract(1,'months').startOf("month").format("YYYY-MM-DD")
          this.to = moment().subtract(1,'months').endOf("month").format("YYYY-MM-DD")
          this.toSelected = moment().subtract(1,'months').endOf("month").format("YYYY-MM-DD")
        }else if(val == "lastThreeMonths"){
          this.lastRange = val;
          this.from = moment().subtract(3,'months').startOf("month").format("YYYY-MM-DD")
          this.fromSelected = moment().subtract(3,'months').startOf("month").format("YYYY-MM-DD")
          this.to = moment().endOf("month").format("YYYY-MM-DD")
          this.toSelected = moment().endOf("month").format("YYYY-MM-DD")
        }else if(val == "currentYear"){
          this.lastRange = val;
          this.from = moment().startOf("year").format("YYYY-MM-DD")
          this.fromSelected = moment().startOf("year").format("YYYY-MM-DD")
          this.to = moment().endOf("year").format("YYYY-MM-DD")
          this.toSelected = moment().endOf("year").format("YYYY-MM-DD")
        }else if(val == "prevYear"){
          this.lastRange = val;
          this.from = moment().subtract(1,'years').startOf("year").format("YYYY-MM-DD")
          this.fromSelected = moment().subtract(1,'years').startOf("year").format("YYYY-MM-DD")
          this.to = moment().subtract(1,'years').endOf("year").format("YYYY-MM-DD")
          this.toSelected = moment().subtract(1,'years').endOf("year").format("YYYY-MM-DD")
        }
      },
    },
    mounted: function() {},
    methods: {
        load: async function() {
            var result = await axios.get("/desktop/maintenaces.json")
            var items = []
            for (var i = result.data.length - 1; i >= 0; i--) {
              var maintenace =  result.data[i];
              items.push({
                'date': maintenace[0][1],
                'name': maintenace[0][0],
                'what': maintenace[0][2],
                'devices': maintenace[1]
              });
            }
            this.maintenaces = items;
            this.loaded = true;
        },
        setMaintenacesOrder: function(order) {
            if (this.ordermaintenacesby == order) {
                if (this.ordermaintenace == 'desc') {
                    this.ordermaintenace = 'asc'
                } else if (this.ordermaintenace == 'asc') {
                    this.ordermaintenace = 'desc'
                }

            } else {
                this.ordermaintenacesby = order;
            }
        },
        applyChanges: function(){
            this.from = this.fromSelected;
            this.to = this.toSelected;
        }
    },
    props: { address: Object },
    computed: {
      listMaintenaces() {
        var that = this;
        return _.filter(
          _.orderBy(this.maintenaces, this.ordermaintenacesby, this.ordermaintenace),
            function(item) {
                return (that.selected_kinds.indexOf(item.what) >= 0 || that.selected_kinds.length == 0) && (item.name.toUpperCase().indexOf(that.maintenacesearch.toUpperCase()) >= 0) && moment(item.date).isBetween(that.from, that.to)
            }
        );
      },
      kinds(){
        return _.uniq(_.map(this.maintenaces, 'what'));
      }
    },

}
</script>
<style scoped>
    div {
        margin-left: auto;
        left: auto;
        right: auto;
        line-height: 2;
    }

    .baseheader {
        background-color: #DADADA;
        margin-bottom: 0px;
        padding-top: 15px;
        padding-bottom: 15px;
    }
    select{
      background-color: white !important;
      border-radius: 4px !important;
      border-width: 1px !important;
      border-style: solid !important;
      border-color: rgb(140, 140, 140) !important;
      padding-left: 5px !important;
      padding-top: 0px;
      padding-bottom: 0px;
      display: block;
    }
</style>